export default function lineBreaker(str = '') {
  const split = str.trim()?.split(/\r\n|\n/g)

  return split.join('<br />')
}
